import React, { useState } from "react";
import { Separator } from "@/components/ui/separator";
import { SidebarTrigger } from "@/components/ui/sidebar";
import { useAppDispatch, useAppSelector } from "@/store/hooks";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Button } from "../ui/button";
import { ArrowLeftRight, BellIcon } from "lucide-react";
import { executeGraphQLMutation } from "@/utils/helper/graphql-helper";
import { updateUserInfo } from "@/graphql/mutations";
import { generateClient } from "@/utils/helper/aws-generateClient-singleton";
import ls from "@/utils/SecureLS";
import { setUser } from "@/store/slices/authSlice";
import { DropdownMenu, DropdownMenuContent, DropdownMenuTrigger } from "../ui/dropdown-menu";
import { IconItem } from "@/types/AppTypes";
import NotificationDropdown from "../notificationDropdown/NotificationDropdown";
const DashboardHeader = () => {
  const { user } = useAppSelector((state) => state.auth);
  const client = generateClient();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [headerTitle, setHeaderTitle] = React.useState("");
  const title = {
    "/profile": "Profile",
    "/seller": "Manage Inventory",
    "/add-product": "Add Product",
    "/add-category": "Add Category",
    "/add-brand": "Add Brand",
    "/edit-product": "Edit Product",
    "/edit-category": "Edit Category",
    "/edit-brand": "Edit Brand",
    "/seller/sales": "Sales Analytics",
    "/payouts": "Payouts",
  };
  const location = useLocation();
  React.useEffect(() => {
    const currentPath = location.pathname;
    const matchedKey = Object.keys(title)
      .sort((a, b) => b.length - a.length)
      .find((key) => {
        const regex = new RegExp(`(^|/)${key.replace(/^\//, "")}(/|$)`);
        return regex.test(currentPath);
      });
    setHeaderTitle(matchedKey ? title[matchedKey as keyof typeof title] : "Seller Dashboard");
  }, [location.pathname]);



  const icons: IconItem[] = [
    // {
    //   icon: <Search className="h-4 w-4 group-hover:text-white" />,
    //   label: "Search",
    //   hasDropdown: true,
    //   dropdownContent: (
    //     <SearchDropdown />
    //   ),
    // },
    // {
    //   icon: <Zap className="h-4 w-4 group-hover:text-white" />,
    //   label: "Quick Reorder",
    //   action: "/quick-reorder",
    //   className: "hidden md:block",
    // },
    {
      icon: <BellIcon className="h-4 w-4 group-hover:text-white" />,
      label: "Notifications",
      NotificationCount: 0,
      hasDropdown: true,
      dropdownContent: <NotificationDropdown />,
    },
    // {
    //   icon: <User className="h-4 w-4 group-hover:text-white" />,
    //   label: "Profile",
    //   hasDropdown: true,
    //   dropdownContent: <UserDropdown />,
    //   className: "hidden md:block",
    // },

    // {
    //   icon: <ShoppingCart className="h-4 w-4 group-hover:text-white" />,
    //   label: "Cart",
    //   action: "/cart",
    //   NotificationCount: cartItemsQuantity,
    // },
  ];

  return (
    <header className="group-has-data-[collapsible=icon]/sidebar-wrapper:h-12 flex h-16 shrink-0 items-center gap-2 border-b transition-[width,height] ease-linear justify-between pr-6">
      <div className="flex w-full items-center gap-1 px-4 lg:gap-2 lg:px-6">
        <SidebarTrigger className="-ml-1" />
        <Separator orientation="vertical" className="mx-2 data-[orientation=vertical]:h-4" />
        <h1 className="text-xl font-medium">PALETTE</h1>
      </div>
      <div className="flex justify-between items-center ">
            <div className="ml-4 md:ml-0 flex items-center md:space-x-4">
              {icons.map((item, index) => (
                <div key={index} className={`relative ${item.className || ""}`}>
                  {item.hasDropdown ? (
                    <DropdownMenu>
                      <DropdownMenuTrigger asChild>
                        <button
                          className="group p-3 hover:bg-icon-hover rounded-md relative "
                          title={item?.label}
                        >
                          {item?.icon}
                          {(item.NotificationCount ?? 0) > 0 && (
                            <span className="absolute top-0 right-0 bg-red-500 text-white text-xs rounded-full h-5 w-5 flex items-center justify-center">
                              {item.NotificationCount}
                            </span>
                          )}
                        </button>
                      </DropdownMenuTrigger>
                      <DropdownMenuContent align="end" className=" py-1 bg-white">
                        {item.dropdownContent}
                      </DropdownMenuContent>
                    </DropdownMenu>
                  ) : (
                    <Link to={item.action || "#"}>
                      <button
                        className="group p-3 hover:bg-icon-hover rounded-md relative"
                        title={item.label}
                      >
                        {item.icon}
                        {(item.NotificationCount ?? 0) > 0 && (
                          <span className="absolute top-0 right-0 bg-red-500 text-white text-xs rounded-full h-5 w-5 flex items-center justify-center">
                            {item.NotificationCount}
                          </span>
                        )}
                      </button>
                    </Link>
                  )}
                </div>
              ))}
            </div>
           
          </div>
    
    </header>
  );
};

export default DashboardHeader;
